import React from 'react';
import { ClipboardCheckIcon, ListOrderedIcon, MessagesSquareIcon, QuoteIcon, TargetIcon, TimerIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { ctaMicrocopy, plan } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const icons: Record<(typeof plan.features)[number]['icon'], LucideIcon> = {
  goal: TargetIcon,
  timer: TimerIcon,
  steps: ListOrderedIcon,
  questions: MessagesSquareIcon,
  quote: QuoteIcon,
  action: ClipboardCheckIcon
};
const numberColors = ['text-sun', 'text-coral', 'text-violet', 'text-white'];
const tiles = ['bg-sun text-ink', 'bg-coral text-white', 'bg-violet text-white', 'bg-white text-brand'];

/** How it works + what every complete class has */
export function SolutionSection() {
  return <section aria-labelledby="plan-title" className="bg-brand py-12 md:py-20" data-id="element-219" data-mp="kt3g33octaqd">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-220" data-mp="fujsyzy0xswf">
        <SectionHeading id="plan-title" tone="dark" eyebrow={plan.eyebrow} title={plan.title} sub={plan.text} data-id="element-221" data-mp="frnwzh5qleam" />

        <ol className="mt-10 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-4 md:gap-4" data-id="element-222" data-mp="3b9fev7496b0f">
          {plan.steps.map((step, i) => <li key={step.title} className="rounded-xl bg-brand-dark p-4 md:p-6" data-id="element-223" data-mp="3fa91zy9vfls9" data-mpi={i}>
              <span className={`font-display text-[2.2rem] font-black leading-none md:text-[2.8rem] ${numberColors[i % numberColors.length]}`} data-id="element-224" data-mp="3kawuyphnucp4">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-2 font-display text-[16px] font-black tracking-tight text-white md:text-[18px]" data-id="element-225" data-mp="3u7jdh7mikrnz">{step.title}</h3>
              <p className="mt-1 text-[14px] leading-snug text-white/80 md:text-[15px]" data-id="element-226" data-mp="2uoyzrx1qgch">{step.text}</p>
            </li>)}
        </ol>

        <h3 className="mt-12 text-center font-display text-[13px] font-black tracking-[0.14em] text-sun" data-id="element-227" data-mp="butsqz9bhg86">{plan.featuresTitle}</h3>
        <ul className="mt-5 grid gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3" data-id="element-228" data-mp="gug9hioctelq">
          {plan.features.map((f, i) => {
          const Icon = icons[f.icon];
          return <li key={f.title} className="flex gap-4 rounded-xl bg-brand-dark p-5" data-id="element-229" data-mp="27yhw9ezebqob" data-mpi={i}>
                <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${tiles[i % tiles.length]}`} data-id="element-230" data-mp="2mn4kk6703sro">
                  <Icon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-231" data-mp="2hv4edw0c83mn" />
                </span>
                <div data-id="element-232" data-mp="2vlpxnltpefl2">
                  <p className="font-display text-[16px] font-extrabold leading-snug text-white" data-id="element-233" data-mp="2vpdr6kz5f1zs">{f.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/80" data-id="element-234" data-mp="2ro1xo4d5lwmb">{f.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 flex max-w-[420px] justify-center md:mt-12" data-id="element-235" data-mp="30mx5fkvujerq">
          <CtaButton microcopy={ctaMicrocopy} microTone="light" align="center" data-id="element-236" data-mp="1b88ulo2wm4vt" />
        </div>
      </div>
    </section>;
}